var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveExit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32.5,
    height: 32.5,
    viewBox: "0 0 32.5 32.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M6.875 15C7.56536 15 8.125 15.5596 8.125 16.25C8.125 16.9404 7.56536 17.5 6.875 17.5H2.5V30H30V17.5H25.625C24.9346 17.5 24.375 16.9404 24.375 16.25C24.375 15.5596 24.9346 15 25.625 15H30.417C31.5673 15.0002 32.4998 15.9327 32.5 17.083V30.417C32.4998 31.5673 31.5673 32.4998 30.417 32.5H2.08301C0.932673 32.4998 0.000176087 31.5673 0 30.417V17.083C0.000176076 15.9327 0.932672 15.0002 2.08301 15H6.875ZM22.917 23.333C23.6071 23.3332 24.1668 23.8929 24.167 24.583C24.167 25.2733 23.6072 25.8328 22.917 25.833H9.58301C8.8928 25.8328 8.33301 25.2733 8.33301 24.583C8.33318 23.8929 8.89291 23.3332 9.58301 23.333H22.917ZM16.25 0C16.9404 3.01764e-08 17.5 0.559644 17.5 1.25V14.8984L23.6992 8.69922C24.1873 8.21114 24.9786 8.21129 25.4668 8.69922C25.955 9.18737 25.955 9.97864 25.4668 10.4668L17.1338 18.8008C16.6457 19.2887 15.8543 19.2886 15.3662 18.8008L7.0332 10.4668C6.54505 9.97864 6.54505 9.18737 7.0332 8.69922C7.52138 8.21139 8.31273 8.21117 8.80078 8.69922L15 14.8984V1.25C15 0.559644 15.5596 -1.40698e-08 16.25 0Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveExit);
export default __webpack_public_path__ + "static/media/save-exit.bc32e853ba1ea675a1bc83fbc4987f9e.svg";
export { ForwardRef as ReactComponent };